import CryptoJS from "crypto-js";
import { ENV } from "../main/config";
class EncryptionUtils {
  private static key: string;
  private static init(): void {
    let k = ENV.encryptionKey || "auditzen-default-encryption-key-32-chars";
    if (k.length < 32) k = k.padEnd(32, "0");
    if (k.length > 32) k = k.substring(0, 32);
    this.key = k;
  }
  private static encrypt(value: any): string {
    if (!this.key) this.init();
    const text = typeof value === "string" ? value : JSON.stringify(value);
    return CryptoJS.AES.encrypt(text, this.key).toString();
  }
  private static decrypt<T = any>(cipherText: string): T | null {
    if (!this.key) this.init();
    try {
      const bytes = CryptoJS.AES.decrypt(cipherText, this.key);
      const plain = bytes.toString(CryptoJS.enc.Utf8);
      if (!plain) return null;
      try {
        return JSON.parse(plain) as T;
      } catch {
        return plain as T;
      }
    } catch (err) {
      console.error("EncryptionUtils decrypt failed:", err);
      return null;
    }
  }
  static set(key: string, value: any): void {
    localStorage.setItem(key, this.encrypt(value));
  }
  static get<T = string>(key: string, fallback: T = "" as any): T {
    const encrypted = localStorage.getItem(key);
    if (!encrypted) return fallback;
    const decrypted = this.decrypt<T>(encrypted);
    return decrypted === null ? fallback : decrypted;
  }
  static remove(key: string): void {
    localStorage.removeItem(key);
  }
  static getAuthInfo(): {
    roleId: string; roleName: string; userRole: string; clientName: string; campaignName: string, functionCampaignName: string, role: string,
  } {
    return { role: this.get("roleName"), roleId: this.get("roleId"), roleName: this.get("roleName"), userRole: this.get("roleName"), clientName: this.get("clientName"), campaignName: this.get("campaignName"), functionCampaignName: this.get("functionCampaignName"), };
  }
}
export default EncryptionUtils;